import { round } from 'lodash/math';
import { STUDY_TYPE } from '../../../../../redux/reducers/studyTypeReducers';
import { SURVEY_TYPE } from '../../../../../common/components/pdf_generator/templates/SurveyPDFTemplate/utils/DataUtils';

// Survey type configuration for different study types
export const SURVEY_TYPE_CONFIG = {
  [STUDY_TYPE.US_DUAL_ALLOCATION]: [
    SURVEY_TYPE.LABOR_DUAL,
    SURVEY_TYPE.LABOR_PROJECT_SUBSTANTIATION,
    SURVEY_TYPE.LABOR_BC_SUBSTANTIATION,
  ],
  [STUDY_TYPE.UK_DUAL_ALLOCATION]: [
    SURVEY_TYPE.LABOR_DUAL,
    SURVEY_TYPE.LABOR_PROJECT_SUBSTANTIATION,
    SURVEY_TYPE.LABOR_BC_SUBSTANTIATION,
  ],
  [STUDY_TYPE.US_SINGLE_ALLOCATION]: [SURVEY_TYPE.LABOR],
};

// Helper to get survey types for a study type
export const getSurveyTypesForStudy = studyType =>
  SURVEY_TYPE_CONFIG[studyType] || [SURVEY_TYPE.LABOR];

// Metric formatting configuration
export const METRIC_FORMATTERS = {
  AverageDaysToComplete: value => `${round(value, 1)} days`,
  percentage: value => `${Math.round(value)}%`,
  default: value => value.toFixed(1),
};

// Metric types that require special formatting
export const METRIC_TYPES = {
  AVERAGE_DAYS: 'AverageDaysToComplete',
  PERCENTAGE: 'percentage',
  DEFAULT: 'default',
};

// Configuration for metric formatting rules
export const METRIC_FORMAT_CONFIG = {
  [METRIC_TYPES.AVERAGE_DAYS]: {
    formatter: METRIC_FORMATTERS.AverageDaysToComplete,
    precision: 1,
  },
  [METRIC_TYPES.PERCENTAGE]: {
    formatter: METRIC_FORMATTERS.percentage,
    precision: 0,
  },
  [METRIC_TYPES.DEFAULT]: {
    formatter: METRIC_FORMATTERS.default,
    precision: 1,
  },
};

// Helper to get formatter for a metric
export const getMetricFormatter = (key, isPercentage) => {
  if (isPercentage) return METRIC_FORMATTERS.percentage;
  if (key === METRIC_TYPES.AVERAGE_DAYS) return METRIC_FORMATTERS.AverageDaysToComplete;
  return METRIC_FORMATTERS.default;
};

const METRICS = {
  ON_TIME_COMPLETION_RATE: {
    label: 'On-time completion rate',
    key: 'OnTimeCompletionRate',
    isPercentage: true,
  },
  FIRST_DAY_COMPLETION_RATE: {
    label: '24hr completion rate',
    key: 'FirstDayCompletionRate',
    isPercentage: true,
  },
  SURVEY_REASSIGNMENT_RATE: {
    label: 'Re-assignment rate',
    key: 'SurveyReassignmentRate',
    isPercentage: true,
  },
  SECONDARY_ASSIGNEE_RATE: {
    label: 'Secondary assignment rate',
    key: 'SecondaryAssigneeRate',
    isPercentage: true,
  },
  AVERAGE_NUMBER_OF_SECONDARY_ASSIGNEES: {
    label: 'Average # of secondary assignees',
    key: 'AverageNumberOfSecondaryAssignees',
    isPercentage: false,
  },
};

// Additional metrics for dual allocation and substantiation studies
const DUAL_ALLOCATION_METRICS = {
  SURVEY_OPEN_RATE: {
    label: 'Survey open rate',
    key: 'SurveyOpenRate',
    isPercentage: true,
  },
  COMPLETION_RATE: {
    label: 'Completion rate',
    key: 'CompletionRate',
    isPercentage: true,
  },
  AVERAGE_DAYS_TO_COMPLETE: {
    label: 'Average days to complete',
    key: 'AverageDaysToComplete',
    isPercentage: false,
  },
  FIRST_TIME_COMPLETION_RATE: {
    label: 'First time completion rate',
    key: 'FirstTimeCompletionRate',
    isPercentage: true,
  },
};

export default METRICS;
export { DUAL_ALLOCATION_METRICS };
